import { GQtyError } from "gqty";

const AUTHORIZATION_ERROR_CODE = "AUTHORIZATION_DENIED";
const AUTHORIZATION_ERROR_MESSAGES = new Set([
  "Unauthorized.",
  "You are not authorized to perform this action.",
  "You are not authorized to use this field in filters, sorting or grouping.",
]);

export const permissionDeniedMessage = `You do not have permission to view this resource.`;

export function isAuthorizationError(error: unknown): boolean {
  return (
    error instanceof GQtyError &&
    (AUTHORIZATION_ERROR_MESSAGES.has(error.message) ||
      error.graphQLErrors?.some(
        ({ message, extensions }) =>
          extensions.code === AUTHORIZATION_ERROR_CODE ||
          AUTHORIZATION_ERROR_MESSAGES.has(message),
      ) === true)
  );
}
